import JigsawEvent from "./JigsawEvent";
import { useEffect } from "react";
import useViewer from "./useViewer";

export default function useJigsawEvent(
  events: JigsawEvent | Array<JigsawEvent>,
  cb: jigsaw.JigsawEventCallback
) {
  const viewer = useViewer().viewer;

  useEffect(() => {
    const eventArray = Array.isArray(events) ? events : [events];

    if (viewer) {
      eventArray.forEach(e => {
        viewer.bind(e, cb);
      });
      return () => {
        eventArray.forEach(e => {
          viewer.unbind(e, cb);
        });
      };
    }
  }, [viewer, cb, events]);
}
